

var stogeData = {
  "preview": {},
  "item": {},
  "variant_id": {}
};

$(window).on('load', function(){

  if ($('.simulator-btn').length) {

    var simulator_btn_output = `
    <img src="//aruci.jp/cdn/shop/t/110/assets/pc_before.svg?v=64032635455084213711780913450" class="pc is-before" alt="シュミレータを開く">
    <img src="//aruci.jp/cdn/shop/t/110/assets/sp_before.svg?v=5019036783389738641780913450" class="sp is-before" alt="シュミレータを開く">

    <img src="//aruci.jp/cdn/shop/t/110/assets/pc_after.svg?v=79787572908480925021780913450" class="pc is-after" alt="シュミレータを開く">
    <img src="//aruci.jp/cdn/shop/t/110/assets/sp_after.svg?v=4422645950631461881780913450" class="sp is-after" alt="シュミレータを開く">
`;

    $('.simulator-btn_inr').append(simulator_btn_output);
  }
    
  localStorageData = localStorage.getItem('itemPreview');
  if (localStorageData) {
    stogeData = JSON.parse(localStorageData);
    // 後方互換性: variant_idプロパティがない場合は初期化
    if (!stogeData['variant_id']) {
      stogeData['variant_id'] = {};
    }
  }

    if (stogeData['preview'][0] || stogeData['preview'][1] || stogeData['preview'][2] || stogeData['preview'][3]) {

    $('.simulator-btn').attr('data-sim-btn', 'after');
  }

    if ($('#custom-simulator').length && $('#custom-simulator--json').length) {

        function escapeRegExp(string) {

          var output = string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');

          var character = {

          '<' : '&lt;',
          '>' : '&gt;',
          '&' : '&amp;',
          '"' : '&quot;',

          "'" : '&#039;',
          ':' : '&#058;'
          }

          output = output.replace(/[<>&"':]/g, (c) => {return character[c];});

          return output;
        }


        function getParam(searchText){

          var decodeData = decodeURIComponent(location.search);

            if (decodeData && (decodeData.indexOf('?' + searchText + '=') !== -1 || decodeData.indexOf('&' + searchText + '=') !== -1)) {
              var regex = new RegExp("[?&]" + searchText + "(=([^&#]*)|&|#|$)");

              var text = regex.exec(decodeData)[2];

              var output = escapeRegExp(text);
              return output;

            } else {
              return false;
            }
        }


    var simulatorURL = getParam('simulator');
    if (simulatorURL === "true") {
      $('#custom-simulator').attr('data-simulator-state', 'open');
    }

    var data_get = $('#custom-simulator--json').text();
    var data = JSON.parse(data_get);

        var asset_url = `//aruci.jp/cdn/shop/t/110/assets/replace?v=25542`;

        var assets_before = asset_url.replace(/replace.*/g, '');
        var assets_after = asset_url.replace(/.*?replace/g, '');
      
    var assets_path = `assets/img/`;


    var output = '';
    var preview_output = '';
    var category_output = '';
    var select_output = '';

    var name_output = '';

    preview_output += `<div class="custom-preview">`;
    preview_output += `<div class="custom-preview_inr">`;
    preview_output += `<div class="custom-preview--img">`;

    select_output += `<div class="custom-select">`;
    select_output += `<div class="custom-select_inr">`;

    category_output += `<div class="custom-category">`;
    category_output += `<div class="custom-category_inr">`;
    category_output += `<ul>`;

    $.each(data, function(i, e){
      // Initialize default variant_id if not already set
      if (typeof stogeData['variant_id'][i] === 'undefined' && e.list[0].variant_id) {
        stogeData['variant_id'][i] = e.list[0].variant_id;
      }

      preview_output += `<img src="${assets_before}${e.list[0].img}${assets_after}" data-preview-type="${i}" alt="${e.list[0].color}" />`;


      if (typeof stogeData['preview'][i] !== 'undefined') {
        preview_output += `<img src="${stogeData['preview'][i]}" data-preview-type="${i}" alt="${e.list[0].color}" />`;

      } else {
        preview_output += `<img src="${assets_before}${e.list[0].img}${assets_after}" data-preview-type="${i}" alt="${e.list[0].color}" />`;

      }

      category_output += `<li class="custom-category--list" data-category-type="${i}">`;
      category_output += `<div class="custom-category--list_inr">`;
      category_output += `<div class="custom-category--img">`;
      
      category_output += `<img src="${assets_before}${e.icon}${assets_after}" alt="${e.title}" />`;
      
      category_output += `</div>`;
      category_output += `<div class="custom-category--text">`;
      category_output += `<span>STEP ${i+1}</span>`;
      category_output += `<h3>${e.title}</h3>`;
      category_output += `</div>`;
      category_output += `</div>`;
      category_output += `</li>`;


      select_output += `<div class="custom-select__type" data-select-type="${i}">`;
      select_output += `<div class="custom-select__type_inr">`;
      select_output += `<div class="custom-select--title" data-select-type="${i}" data-select-title="${e.title2}"></div>`;
      select_output += `<ul>`;

      name_output += `<div class="select-item"><span class="select-item__title">${e.title}</span>`;
      if (typeof stogeData['item'][i] !== 'undefined') {
        name_output += `<span class="select-item__${i}">${stogeData['item'][i]}</span>`;

      } else {
        name_output += `<span class="select-item__${i}">${e.list[0].color}</span>`;
      }
      name_output += `</div>`;

      $.each(e.list, function(j, v){
        var sub_img = v.img.replace(/(\.png)/g, '_2$1');
        var variant_id = v.variant_id || '';
        select_output += `<li class="custom-select__list" data-preview-img="${assets_before}${v.img}${assets_after}" data-variant-id="${variant_id}">`;
        select_output += `<div class="custom-select__list_inr">`;
        select_output += `<div class="custom-select--img"><img src="${assets_before}${sub_img}${assets_after}" alt="${v.color}" /></div>`;
        select_output += `<div class="custom-select--text"><span>${v.color}</span></div>`;
        select_output += `</div>`;
        select_output += `</li>`;

      })
      select_output += `</ul>`;
      select_output += `<div class="select--close"></div>`;
      select_output += `</div>`;
      select_output += `</div>`;

    })

    select_output += `</div>`;
    select_output += `</div>`;

    preview_output += `</div>`;

    preview_output += `<div class="custom-preview--text">`;
    preview_output += name_output;
    preview_output += `</div>`;

    preview_output += `</div>`;
    preview_output += `</div>`;

    category_output += `</ul>`;
    category_output += `</div>`;
    category_output += `</div>`;

    output += preview_output;
    output += `<div class="custom-panel" data-panel-type="category">`;
    output += `<div class="custom-panel_inr">`;
    output += category_output + select_output;
    
    output += `</div>`;
    
    output += `</div>`;
    output += `<div class="simulator-save__btn"><div class="simulator-save__btn_inr"><span>実際にカスタマイズを始める</span><img src="${assets_before}save-btn.svg${assets_after}" /></div></div>`;
    output += `<div class="simulator-cart__btn"><div class="simulator-cart__btn_inr"><span>カートに追加</span></div></div>`;



var outer_data = `<div class="custom-simulator">
<div class="custom-simulator__backscreen"></div>
  <div class="custom-simulator_inr">
    <div class="custom-simulator--close">
      <div class="custom-simulator--close_inr">
      </div>
    </div>

    <div class="custom-simulator--title">
      <h2>Simulate<span>-シザーケースをカスタム-</span></h2>
    </div>

    <div class="custom-simulator__body">
      <div class="custom-simulator__body_inr">

      ${output}

      </div>
    </div>
  </div>
</div>`;


    $('#custom-simulator').html(outer_data);


    $('html').on('click', function(event){

      var target = $(event.target);

      if (target.is('.custom-simulator--open') || target.parents().is('.custom-simulator--open') ||  target.parents().is('.simulator-btn')) {
        $('#custom-simulator').attr('data-simulator-state', 'open');
      }

      if (target.is('.custom-simulator--close') || target.is('.custom-simulator__backscreen') || target.parents().is('.simulator-save__btn')) {
        $('#custom-simulator').removeAttr('data-simulator-state');

        var simulatorURL = getParam('simulator');
        if (simulatorURL === "true") {
          var changeURL = location.href.replace(/(\?simulator=)true.*/g, '$1false')
          history.pushState(null ,null, changeURL);
        }

      }

      if (target.is('.custom-category--list')) {
        var category_type = target.attr('data-category-type');
        $('.custom-panel').attr('data-panel-type', 'select');

        $('.custom-select__type.is-select ul').scrollTop(0);
        $('.custom-select__type.is-select ul').scrollLeft(0);

        $(`.custom-select__type:not([data-select-type="${category_type}"])`).removeClass('is-select');
        $(`[data-select-type="${category_type}"]`).addClass('is-select');

      }

      if (target.is('.custom-select__list')) {
        var preview_data = target.attr('data-preview-img');
        var variant_id = target.attr('data-variant-id');
        var category_type = target.parents('.custom-select__type').attr('data-select-type');

        var item_name = target.find('.custom-select--text').text();

        $(`img[data-preview-type="${category_type}"]`).attr('src', preview_data);
        $(`.custom-preview--text .select-item__${category_type}`).html(item_name);


        target.parents('.custom-select__type').find(`.custom-select__list:not([data-preview-img="${preview_data}"])`).removeClass('is-select');
        target.parents('.custom-select__type').find(`[data-preview-img="${preview_data}"]`).addClass('is-select');

        stogeData["preview"][category_type] = preview_data;
        stogeData["item"][category_type] = item_name;
        if (variant_id) {
          stogeData["variant_id"][category_type] = variant_id;
        }
        localStorage.setItem('itemPreview', JSON.stringify(stogeData));

        $('.simulator-btn').attr('data-sim-btn', 'after');

      }

      if (target.is('.select--close')) {
        $('.custom-panel').attr('data-panel-type', 'category');

      }

      // カートに追加ボタンのクリックハンドラー
      if (target.is('.simulator-cart__btn') || target.parents('.simulator-cart__btn').length) {
        var add_items = [];
        var hasItems = false;
        var unixtime = new Date().getTime();

        // 各カテゴリのvariant_idを収集
        $.each(stogeData['variant_id'], function(category, variant_id) {
          if (variant_id) {
            hasItems = true;
            add_items.push({
              id: parseInt(variant_id),
              quantity: 1,
              properties: {
                '組み合わせID': unixtime
              }
            });
          }
        });

        if (!hasItems) {
          // デバッグ情報をコンソールに出力
          console.log('stogeData:', stogeData);
          console.log('variant_id data:', stogeData['variant_id']);
          alert('商品のvariant_idが設定されていません。\n\nShopify管理画面のJSONデータに各商品のvariant_idを追加してください。\n\n詳細はコンソールログを確認してください。');
          return;
        }

        // ローディング表示
        $('.simulator-cart__btn_inr span').text('追加中...');
        $('.simulator-cart__btn').css('pointer-events', 'none');

        // Shopify Cart APIで複数商品を追加
        jQuery.post('/cart/add.js', {
          items: add_items
        })
        .done(function() {
          // 成功時: カートページへ遷移
          window.location.href = '/cart';
        })
        .fail(function(err) {
          console.error('カート追加エラー:', err);
          alert('カートへの追加に失敗しました。もう一度お試しください。');
          $('.simulator-cart__btn_inr span').text('カートに追加');
          $('.simulator-cart__btn').css('pointer-events', 'auto');
        });
      }

    });






  }



  });


      $(window).on('scroll', function(){
  
        if ($('.line_touroku-btn').hasClass('is-active') && !$('.simulator-btn').hasClass('is-active')) {
          $('.simulator-btn').addClass('is-active');
        }
  
        if (!$('.line_touroku-btn').hasClass('is-active') && $('.simulator-btn').hasClass('is-active')) {
          $('.simulator-btn').removeClass('is-active');
        }

    });